const financeResources = {
  en: {
    finance: {
      'finance.title': 'Financial indicators',
      'finance.text1': 'Financial statements',
      'finance.text2': 'Audited reports',

      'finance1.text9':
        'Balance sheet and profit and loss statement as of July 01, 2025',
      'finance1.date9': '01 July 2025',
      'finance1.url9':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2025/01.07.2025%20ru.pdf',

      'finance1.text8':
        'Balance sheet and profit and loss statement as of April 01, 2025',
      'finance1.date8': '10 April 2025',
      'finance1.url8':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2025/01.04.2025_v2_en.pdf',

      'finance1.text7':
        'Balance sheet and profit and loss statement as of January 01, 2025',
      'finance1.date7': '01 January 2025',
      'finance1.url7':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2025/january_eng.pdf',
      'finance1.text6':
        'Balance sheet and profit and loss statement as of October 01, 2024',
      'finance1.date6': '01 October 2024',
      'finance1.url6':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2024/october_eng.pdf',
      'finance1.text5':
        'Balance sheet and profit and loss statement as of July 01, 2024',
      'finance1.date5': '01 July 2024',
      'finance1.url5':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2024/july_eng.xlsx',
      'finance1.text4':
        'Balance sheet and profit and loss statement as of April 01, 2024',
      'finance1.date4': '01 April 2024',
      'finance1.url4':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2024/april.xlsx',
      'finance1.text3':
        'Balance sheet and profit and loss statement as of January 01, 2024',
      'finance1.date3': '01 January 2024',
      'finance1.url3':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2024/january.xlsx',
      'finance1.text2':
        'Balance sheet and profit and loss statement as of October 01, 2023',
      'finance1.date2': '09 October 2023',
      'finance1.url2':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2023/october.xlsx',
      'finance1.text1':
        'Balance sheet and profit and loss statement as of July 01, 2023',
      'finance1.date1': '14 July 2023',
      'finance1.url1':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2023/july.xlsx',
      'finance1.text':
        'Balance sheet and profit and loss statement as of April 01, 2023',
      'finance1.date': '07 April 2023',
      'finance1.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2023/april.xlsx',
      'finance2.text':
        'Balance sheet and profit and loss statement as of January 01, 2023',
      'finance2.date': '01 January 2023',
      'finance2.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2023/january.xlsx',
      'finance3.text':
        'Balance sheet and profit and loss statement as of October 01, 2022',
      'finance3.date': '07 October 2022',
      'finance3.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2022/october.xlsx',
      'finance4.text':
        'Balance sheet and profit and loss statement as of July 01, 2022',
      'finance4.date': '08 July 2022',
      'finance4.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2022/july.xlsx',
      'finance5.text':
        'Balance sheet and profit and loss statement as of April 01, 2022',
      'finance5.date': '01 April 2022',
      'finance5.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2022/april.xlsx',
      'finance6.text':
        'Balance sheet and profit and loss statement as of January 01, 2022',
      'finance6.date': '09 January 2022',
      'finance6.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2022/january.xlsx',
      'finance7.text':
        'Balance sheet and profit and loss statement as of October 01, 2021',
      'finance7.date': '08 October 2021',
      'finance7.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2021/october.xlsx',
      'finance8.text':
        'Balance sheet and profit and loss statement as of July 01, 2021',
      'finance8.date': '09 July 2021',
      'finance8.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2021/july.xlsx',
      'finance9.text':
        'Balance sheet and profit and loss statement as of April 01, 2021',
      'finance9.date': '08 April 2021',
      'finance9.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2021/april.xlsx',
      'finance10.text':
        'Income Statement and Balance Sheet for the first six months to January 01, 2021',
      'finance10.date': '03 january 2021',
      'finance10.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2021/january.xlsx',
      'finance11.text':
        'Income Statement and Balance Sheet for the first six months to October 01, 2020',
      'finance11.date': '07 october 2020',
      'finance11.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2020/october.xlsx',
      'finance12.text':
        'Income Statement and Balance Sheet for the first six months to July 01, 2020',
      'finance12.date': '08 july 2020',
      'finance12.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2020/july.xlsx',
      'finance13.text':
        'Income Statement and Balance Sheet for the first six months to April 01, 2020',
      'finance13.date': '09 april 2020',
      'finance13.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2020/april.xlsx',
      'finance14.text':
        'Income Statement and Balance Sheet for the first six months to January 01, 2020',
      'finance14.date': '13 january 2020',
      'finance14.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2020/january.xlsx',
      'finance15.text':
        'Income Statement and Balance Sheet for the first six months to October 01, 2019',
      'finance15.date': '08 october 2019',
      'finance15.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2019/october.xlsx',
      'finance16.text':
        'Income Statement and Balance Sheet for the first six months to July 01, 2019',
      'finance16.date': '09 july 2019',
      'finance16.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2019/july.xlsx',
      'finance17.text':
        'Income Statement and Balance Sheet for the first six months to April 01, 2019',
      'finance17.date': '08 april 2019',
      'finance17.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2019/april.xlsx',
      'finance18.text':
        'Income Statement and Balance Sheet for the first six months to January 01, 2019',
      'finance18.date': '11 january 2019',
      'finance18.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2019/january.xlsx',
      'finance19.text':
        'Income Statement and Balance Sheet for the first six months to October 01, 2018',
      'finance19.date': '09 october 2018',
      'finance19.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2018/october.xls',
      'finance20.text':
        'Income Statement and Balance Sheet for the first six months to July 01, 2018',
      'finance20.date': '11 july 2018',
      'finance20.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2018/july.xls',
      'finance21.text':
        'Income Statement and Balance Sheet for the first six months to April 01, 2018',
      'finance21.date': '01 april 2018',
      'finance21.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2018/april.xls',
      'finance22.text1':
        'Income Statement and Balance Sheet for the first six months to March 01, 2018',
      'finance22.date1': '01 march 2018',
      'finance22.url1':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2018/march.xls',
      'finance22.text':
        'Income Statement and Balance Sheet for the first six months to January 01, 2018',
      'finance22.date': '01 january 2018',
      'finance22.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2018/january.xls',
      'finance23.text':
        'Income Statement and Balance Sheet for the first six months to October 01, 2017',
      'finance23.date': '01 october 2017',
      'finance23.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2017/october.xls',
      'finance24.text':
        'Income Statement and Balance Sheet for the first six months to July 01, 2017',
      'finance24.date': '01 july 2017',
      'finance24.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2017/july.xls',
      'finance25.text1':
        'Income Statement and Balance Sheet for the first six months to May 01, 2017',
      'finance25.date1': '01 May 2017',
      'finance25.url1':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2017/may.xls',
      'finance25.text':
        'Income Statement and Balance Sheet for the first six months to April 01, 2017',
      'finance25.date': '02 april 2017',
      'finance25.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2017/april.xls',
      'finance26.text1':
        'Income Statement and Balance Sheet for the first six months to February 01, 2017',
      'finance26.date1': '01 february 2017',
      'finance26.url1':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2017/february.xls',
      'finance26.text':
        'Income Statement and Balance Sheet for the first six months to January 01, 2017',
      'finance26.date': '02 january 2017',
      'finance26.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2017/january.xls',
      'finance27.text1':
        'Income Statement and Balance Sheet for the first six months to December 01, 2016',
      'finance27.date1': '01 december 2016',
      'finance27.url1':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2016/december.xls',
      'finance27.text':
        'Income Statement and Balance Sheet for the first six months to October 01, 2016',
      'finance27.date': '01 october 2016',
      'finance27.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2016/october.xls',
      'finance28.text':
        'Income Statement and Balance Sheet for the first six months to July 01, 2016',
      'finance28.date': '01 july 2016',
      'finance28.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2016/july.xls',
      'finance29.text':
        'Balance Sheet for the first three months to April 01, 2016',
      'finance29.date': '01 april 2016',
      'finance29.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2016/april.xls',
      'finance30.text':
        'Income Statement for the first three months to January 05, 2016',
      'finance30.date': '05 january 2016',
      'finance30.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2016/january.xls',
      'finance31.text':
        'Income Statement and Balance Sheet for the first six months to October 01, 2015',
      'finance31.date': '01 october 2015',
      'finance31.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2015/october.xls',
      'finance32.text':
        'Income Statement and Balance Sheet for the first six months to July 01, 2015',
      'finance32.date': '01 july 2015',
      'finance32.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2015/july.xls',
      'finance33.text':
        'Income Statement and Balance Sheet for the first six months to April 01, 2015',
      'finance33.date': '01 april 2015',
      'finance33.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2015/april.xls',
      'finance34.text':
        'Income Statement and Balance Sheet for the first six months to January 01, 2015',
      'finance34.date': '09 january 2015',
      'finance34.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2015/january.xls',
      'finance35.text':
        'Income Statement and Balance Sheet for the first six months to October 01, 2014',
      'finance35.date': '30 september 2014',
      'finance35.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2014/september.xls',
      'finance36.text':
        'Income Statement and Balance Sheet for the first six months to July 01, 2014',
      'finance36.date': '01 july 2014',
      'finance36.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2014/july.xls',
      'finance37.text':
        'Income Statement for the first three months to April 01, 2014',
      'finance37.date': '01 april 2014',
      'finance37.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2014/april_otchet.pdf',
      'finance38.text': 'Balance Sheet for the year ended April 01, 2014',
      'finance38.date': '01 april 2014',
      'finance38.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2014/april_balance.pdf',
      'finance39.text': 'Income Statement for the twelve-month period, 2013',
      'finance39.date': '01 january 2014',
      'finance39.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2014/january.pdf',
      'finance40.text': 'Balance Sheet for the year ended December 31, 2013',
      'finance40.date': '01 december 2013',
      'finance40.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2013/december.pdf',
      'finance41.text':
        'Balance Sheet for the first nine months to September 01, 2013',
      'finance41.date': '01 september 2013',
      'finance41.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2013/september_balance.pdf',
      'finance42.text':
        'Income Statement for the first nine months to September 01, 2013',
      'finance42.date': '01 september 2013',
      'finance42.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2013/september_otchet.pdf',
      'finance43.text':
        'Income Statement for the first six months to July 01, 2013',
      'finance43.date': '01 july 2013',
      'finance43.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2013/july_otchet.pdf',
      'finance44.text':
        'Balance Sheet for the first six months to July 01, 2013',
      'finance44.date': '01 july 2013',
      'finance44.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2013/july_balance.pdf',
      'finance45.text':
        'Income Statement for the first three months to April 01, 2013',
      'finance45.date': '01 april 2013',
      'finance45.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2013/april_otchet.pdf',
      'finance46.text':
        'Balance Sheet for the first three months to April 01, 2013',
      'finance46.date': '01 april 2013',
      'finance46.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2013/april_balance.pdf',
      'audi10.text': 'Audited financial reports for 2023',
      'audi10.date': '29 august 2024',
      'audi10.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/AuditedReports/2024_eng.pdf',
      'audi1.text': 'Audited financial reports for 2022',
      'audi1.date': '02 april 2023',
      'audi1.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/AuditedReports/2023.pdf',
      'audi2.text': 'Audited financial reports for 2021',
      'audi2.date': '02 april 2022',
      'audi2.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/AuditedReports/2022.pdf',
      'audi3.text': 'Audited financial reports for 2020',
      'audi3.date': '08 april 2021',
      'audi3.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/AuditedReports/2021.pdf',
      'audi4.text': 'Audited financial reports for 2019',
      'audi4.date': '01 april 2020',
      'audi4.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/AuditedReports/2020.pdf',
      'audi5.text': 'Audited financial reports for 2018',
      'audi5.date': '01 june 2019',
      'audi5.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/AuditedReports/2019.pdf',
      'audi6.text': 'Audited financial reports for 2017',
      'audi6.date': '01 april 2018',
      'audi6.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/AuditedReports/2018.pdf',
      'audi7.text': 'Audited financial reports for 2016',
      'audi7.date': '01 march 2017',
      'audi7.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/AuditedReports/2017.pdf',
      'audi8.text': 'Audited financial reports for 2015',
      'audi8.date': '05 march 2016',
      'audi8.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/AuditedReports/2016.pdf',
      'audi9.text': 'Audited financial reports for 2014',
      'audi9.date': '09 march 2015',
      'audi9.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/AuditedReports/2015.pdf',
    },
  },
  kz: {
    finance: {
      'finance.title': 'Қаржылық көрсеткіштер',
      'finance.text1': 'Қаржылық есептілік',
      'finance.text2': 'Аудиттелген есептер',

      'finance1.text10':
        '2025 жылғы 01 қазандағы жағдай бойынша бухгалтерлік баланс және кірістер туралы есеп',
      'finance1.date10': '1 қазан 2025',
      'finance1.url10':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2025/01.10.2025_kz.pdf',

      'finance1.text9':
        '2025 жылғы 01 шілдедегі жағдай бойынша бухгалтерлік баланс және кірістер туралы есеп',
      'finance1.date9': '01 шілде 2025',
      'finance1.url9':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2025/01.07.2025%20kz.pdf',

      'finance1.text8':
        '2025 жылғы 01 сәуірдегі жағдай бойынша бухгалтерлік баланс және кірістер туралы есеп',
      'finance1.date8': '10 сәуір 2025',
      'finance1.url8':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2025/01.04.2025_v2_kz.pdf',

      'finance1.text7':
        '2025 жылғы 01 қаңтардағы жағдай бойынша бухгалтерлік баланс және кірістер туралы есеп',
      'finance1.date7': '01 қаңтар 2025',
      'finance1.url7':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2025/january_kz.pdf',
      'finance1.text6':
        '2024 жылғы 01 қазандағы жағдай бойынша кірістер мен залалдар туралы есептеме және бухгалтерлік теңгерім',
      'finance1.date6': '01 қазан 2024',
      'finance1.url6':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2024/october_kz.pdf',
      'finance1.text5':
        '2024 жылғы 01 шілдедегі жағдай бойынша бухгалтерлік баланс және кірістер туралы есеп',
      'finance1.date5': '01 шілде 2024',
      'finance1.url5':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2024/july_kz.xlsx',
      'finance1.text4':
        '2024 жылғы 01 сәуірдегі жағдай бойынша бухгалтерлік баланс және кірістер туралы есеп',
      'finance1.date4': '01 сәуір 2024',
      'finance1.url4':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2024/010424_kz.xlsx',
      'finance1.text3':
        '2024 жылғы 01 қаңтардағы жағдай бойынша бухгалтерлік баланс және кірістер туралы есеп',
      'finance1.date3': '01 қаңтар 2024',
      'finance1.url3':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2024/01.01.24_kz.xlsx',
      'finance1.text2':
        '2023 жылғы 01 қазандағы жағдай бойынша кірістер мен залалдар туралы есептеме және бухгалтерлік теңгерім',
      'finance1.date2': '09 Қазан 2023',
      'finance1.url2':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2023/01.10.23_kz.xlsx',
      'finance1.text1':
        '2023 жылғы 01 шілдедегі жағдай бойынша Кірістер мен залалдар туралы есептеме және бухгалтерлік теңгерім',
      'finance1.date1': '14 шілде 2023',
      'finance1.url1':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2023/01.07.23_kz.xlsx',
      'finance1.text':
        '2023 жылғы 01 сәуірдегі жағдай бойынша бухгалтерлік баланс және кірістер туралы есеп',
      'finance1.date': '07 сәуір 2023',
      'finance1.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2023/01.04.23_kz.xlsx',
      'finance2.text':
        '2023 жылғы 01 қаңтардағы жағдай бойынша бухгалтерлік баланс және кірістер туралы есеп',
      'finance2.date': '01 қаңтар 2023',
      'finance2.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2023/010123_kz.xlsx',
      'finance3.text':
        '2022 жылғы 01 қазандағы жағдай бойынша бухгалтерлік баланс және пайдалар туралы есеп',
      'finance3.date': '07 қазан 2022',
      'finance3.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2022/011022_kz.xlsx',
      'finance4.text':
        '2022 жылғы 01 шілдедегі жағдай бойынша Кірістер мен залалдар туралы есептеме және бухгалтерлік теңгерім',
      'finance4.date': '08 шілде 2022',
      'finance4.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2022/010722_kz.xlsx',
      'finance5.text':
        '2022 жылғы 01 сәуірдегі жағдай бойынша бухгалтерлік баланс және кірістер туралы есеп',
      'finance5.date': '01 сәуір 2022',
      'finance5.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2022/010422_kz.xlsx',
      'finance6.text':
        '2022 жылғы 01 қаңтардағы жағдай бойынша бухгалтерлік баланс және кірістер туралы есеп',
      'finance6.date': '09 қаңтар 2022',
      'finance6.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2022/010122_kz.xlsx',
      'finance7.text':
        '2021 жылғы 01 қазандағы жағдай бойынша Кірістер мен залалдар туралы есептеме және бухгалтерлік теңгерім',
      'finance7.date': '08 қазан 2021',
      'finance7.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2021/011021_kz.xlsx',
      'finance8.text':
        '2021 жылғы 01 шілдедегі жағдай бойынша Кірістер мен залалдар туралы есептеме және бухгалтерлік теңгерім',
      'finance8.date': '09 шілде 2021',
      'finance8.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2021/010721_kz.xlsx',
      'finance9.text':
        '2021 жылғы 01 сәуірдегі жағдай бойынша Кірістер мен залалдар туралы есептеме және бухгалтерлік теңгерім',
      'finance9.date': '08 сәуір 2021',
      'finance9.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2021/010421_kz.xlsx',
      'finance10.text':
        '2021 жылғы 01 қантардағы жағдай бойынша Кірістер мен залалдар туралы есептеме және бухгалтерлік теңгерім',
      'finance10.date': '03 қаңтар 2021',
      'finance10.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2021/january.xlsx',
      'finance11.text':
        '2020 жылғы 01 қазандағы жағдай бойынша Кірістер мен залалдар туралы есептеме және бухгалтерлік теңгерім',
      'finance11.date': '07 қазан 2020',
      'finance11.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2020/october.xlsx',
      'finance12.text':
        '2020 жылы 01 шiлдедегі жағдай бойынша Кірістер мен залалдар туралы есептеме және бухгалтерлік теңгерім',
      'finance12.date': '08 шілде 2020',
      'finance12.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2020/july.xlsx',
      'finance13.text':
        '2020 жылы 01 cәуірдегі жағдай бойынша Кірістер мен залалдар туралы есептеме және бухгалтерлік теңгерім',
      'finance13.date': '09 сәуір 2020',
      'finance13.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2020/april.xlsx',
      'finance14.text':
        '2020 жылы 01 қантардағы жағдай бойынша Кірістер мен залалдар туралы есептеме және бухгалтерлік теңгерім',
      'finance14.date': '13 қаңтар 2020',
      'finance14.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2020/january.xlsx',
      'finance15.text':
        '2019 жылғы 01 қазандағы жағдай бойынша Кірістер мен залалдар туралы есептеме және бухгалтерлік теңгерім',
      'finance15.date': '08 қазан 2019',
      'finance15.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2019/october.xlsx',
      'finance16.text':
        '2019 жылғы 01 шілдедегі жағдай бойынша Кірістер мен залалдар туралы есептеме және бухгалтерлік теңгерім',
      'finance16.date': '09 шілде 2019',
      'finance16.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2019/july.xlsx',
      'finance17.text':
        '2019 жылғы 01 сәуірдегі жағдай бойынша табыстар мен шығыстар туралы есептеме',
      'finance17.date': '08 сәуір 2019',
      'finance17.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2019/april.xlsx',
      'finance18.text':
        '2019 жылғы 01 қаңтарындағы жағдай бойынша табыстар мен шығыстар туралы есептеме',
      'finance18.date': '11 қаңтар 2019',
      'finance18.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2019/january.xlsx',
      'finance19.text':
        '2018 жылғы 01 қазандағы жағдай бойынша табыстар мен шығыстар туралы есептеме',
      'finance19.date': '09 қазан 2018',
      'finance19.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2018/october.xls',
      'finance20.text':
        '2018 жылғы 01 маусымдағы жағдай бойынша табыстар мен шығыстар туралы есептеме',
      'finance20.date': '11 шілде 2018',
      'finance20.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2018/july.xls',
      'finance21.text':
        '2018 жылғы 01 сәуірдегі жағдай бойынша табыстар мен шығыстар туралы есептеме',
      'finance21.date': '01 сәуір 2018',
      'finance21.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2018/april.xls',
      'finance22.text1':
        '2018 жылғы 01 наурыздағы жағдай бойынша табыстар мен шығыстар туралы есептеме',
      'finance22.date1': '01 наурыз 2018',
      'finance22.url1':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2018/march.xls',
      'finance22.text':
        '2018 жылғы 01 қаңтарындағы жағдай бойынша табыстар мен шығыстар туралы есептеме',
      'finance22.date': '01 қаңтар 2018',
      'finance22.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2018/january.xls',
      'finance23.text':
        '2017 жылғы 01 қазандегі жағдай бойынша табыстар мен шығыстар туралы есептеме',
      'finance23.date': '01 қазан 2017',
      'finance23.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2017/october.xls',
      'finance24.text':
        '2017 жылғы 01 шілдедегі жағдай бойынша Кірістер мен залалдар туралы есептеме және бухгалтерлік теңгерім',
      'finance24.date': '01 шілде 2017',
      'finance24.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2017/july.xls',
      'finance25.text1':
        '2017 жылғы 01 мамырдағы жағдай бойынша табыстар мен шығыстар туралы есептеме',
      'finance25.date1': '01 мамыр 2017',
      'finance25.url1':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2017/may.xls',
      'finance25.text':
        '2017 жылғы 01 сәуірдегі жағдай бойынша табыстар мен шығыстар туралы есептеме',
      'finance25.date': '02 сәуір 2017',
      'finance25.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2017/april.xls',
      'finance26.text1':
        '2017 жылғы 01 ақпандағы жағдай бойынша табыстар мен шығыстар туралы есептеме',
      'finance26.date1': '01 ақпан 2017',
      'finance26.url1':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2017/february.xls',
      'finance26.text':
        '2017 жылғы 01 қаңтарынан жағдай бойынша табыстар мен шығыстар туралы есептеме',
      'finance26.date': '02 қаңтар 2017',
      'finance26.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2017/january.xls',
      'finance27.text1':
        '2016 жылғы 01 желтоқсандағы жағдай бойынша табыстар мен шығыстар туралы есептеме',
      'finance27.date1': '01 желтоқсан 2016',
      'finance27.url1':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2016/december.xls',
      'finance27.text':
        '2016 жылғы 01 қазандегі жағдай бойынша табыстар мен шығыстар туралы есептеме',
      'finance27.date': '01 қазан 2016',
      'finance27.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2016/october.xls',
      'finance28.text':
        '2016 жылғы 01 шілдедегі жағдай бойынша табыстар мен шығыстар туралы есептеме',
      'finance28.date': '01 шілде 2016',
      'finance28.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2016/july.xls',
      'finance29.text':
        '2016 жылғы 01 сәуірдегі жағдай бойынша табыстар мен шығыстар туралы есептеме',
      'finance29.date': '01 сәуір 2016',
      'finance29.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2016/april.xls',
      'finance30.text':
        '2016 жылғы 05 қаңтардағы жағдай бойынша табыстар мен шығыстар туралы есептеме',
      'finance30.date': '05 қаңтар 2016',
      'finance30.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2016/january.xls',
      'finance31.text':
        '2015 жылғы 01 қазандегі жағдай бойынша Кірістер мен залалдар туралы есептеме және бухгалтерлік теңгерім',
      'finance31.date': '01 қазан 2015',
      'finance31.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2015/october.xls',
      'finance32.text':
        '2015 жылғы 01 шілдедегі жағдай бойынша Кірістер мен залалдар туралы есептеме және бухгалтерлік теңгерім',
      'finance32.date': '01 шілде 2015',
      'finance32.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2015/july.xls',
      'finance33.text':
        '2015 жылғы 01 сәуірдегі жағдай бойынша табыстар мен шығыстар туралы есептеме',
      'finance33.date': '01 сәуір 2015',
      'finance33.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2015/april.xls',
      'finance34.text':
        '2015 жылғы 01 қаңтарынан жағдай бойынша табыстар мен шығыстар туралы есептеме',
      'finance34.date': '09 қаңтар 2015',
      'finance34.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2015/january.xls',
      'finance35.text':
        '2014 жылғы 01 қазандағы жағдай бойынша Кірістер мен залалдар туралы есептеме және бухгалтерлік теңгерім',
      'finance35.date': '30 қыркүйек 2014',
      'finance35.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2014/september.xls',
      'finance36.text':
        '2014 жылғы 01 шілдедегі жағдай бойынша Кірістер мен залалдар туралы есептеме және бухгалтерлік теңгерім',
      'finance36.date': '01 шілде 2014',
      'finance36.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2014/july.xls',
      'finance37.text':
        '2014 жылғы 01 сәуірдегі жағдай бойынша бухгалтерлік теңгерім',
      'finance37.date': '01 сәуір 2014',
      'finance37.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2014/april_otchet.pdf',
      'finance38.text':
        '2014 жылғы 01 сәуірдегі жағдай бойынша Табыстар мен шығыстар туралы есептеме',
      'finance38.date': '01 сәуір 2014',
      'finance38.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2014/april_balance.pdf',
      'finance39.text':
        '2013 жылдың 12 айы бойынша Табыстар мен шығыстар туралы есептеме',
      'finance39.date': '01 қаңтар 2014',
      'finance39.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2014/january.pdf',
      'finance40.text':
        '2013 жылғы 31 желтоқсандағы жағдай бойынша бухгалтерлік теңгерім',
      'finance40.date': '01 желтоқсан 2013',
      'finance40.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2013/december.pdf',
      'finance41.text':
        '2013 жылғы 01 қыркүйектегі жағдай бухгалтерлік теңгерім',
      'finance41.date': '01 қыркүйек 2013',
      'finance41.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2013/september_balance.pdf',
      'finance42.text': '2013 жылғы 01 қыркүйектегі жағдай бойынша теңгерім',
      'finance42.date': '01 қыркүйек 2013',
      'finance42.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2013/september_otchet.pdf',
      'finance43.text':
        '2013 жылғы 01 шілдедегі жағдай бойынша Кірістер мен залалдар туралы есептеме',
      'finance43.date': '01 шілде 2013',
      'finance43.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2013/july_otchet.pdf',
      'finance44.text':
        '2013 жылғы 01 шілдедегі жағдай бойынша бухгалтерлік теңгерім',
      'finance44.date': '01 шілде 2013',
      'finance44.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2013/july_balance.pdf',
      'finance45.text':
        '2013 жылғы 01 сәуірдегі жағдай бойынша бухгалтерлік теңгерім',
      'finance45.date': '01 сәуір 2013',
      'finance45.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2013/april_otchet.pdf',
      'finance46.text':
        '2013 жылғы 01 сәуірдегі жағдай бойынша Кірістер мен залалдар туралы есептеме',
      'finance46.date': '01 сәуір 2013',
      'finance46.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2013/april_balance.pdf',
      'audi11.text': '2024 жылға аудиттелген қаржылық есеп',
      'audi11.date': '13 тамыз 2025',
      'audi11.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/AuditedReports/2025.pdf',
      'audi10.text': '2023 жылға аудиттелген қаржылық есеп',
      'audi10.date': '29 тамыз 2024',
      'audi10.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/AuditedReports/2024.pdf',
      'audi1.text': '2022 жылға аудиттелген қаржылық есеп',
      'audi1.date': '18 сәуір 2023',
      'audi1.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/AuditedReports/2023.pdf',
      'audi2.text': 'Аудиттелетін мәлімдемелер 2021 жыл',
      'audi2.date': '13 сәуір 2022',
      'audi2.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/AuditedReports/2022.pdf',
      'audi3.text': 'Аудиттелетін мәлімдемелер 2020 жыл',
      'audi3.date': '08 сәуір 2021',
      'audi3.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/AuditedReports/2021.pdf',
      'audi4.text': 'Аудиттелетін мәлімдемелер 2019 жыл',
      'audi4.date': '01 сәуір 2020',
      'audi4.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/AuditedReports/2020.pdf',
      'audi5.text': 'Аудиттелетін мәлімдемелер 2018 жыл',
      'audi5.date': '01 маусым 2019',
      'audi5.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/AuditedReports/2019.pdf',
      'audi6.text': 'Аудиттелетін мәлімдемелер 2017 жыл',
      'audi6.date': '21 сәуір 2018',
      'audi6.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/AuditedReports/2018.pdf',
      'audi7.text': 'Аудиттелетін мәлімдемелер 2016 жыл',
      'audi7.date': '01 наурыз 2017',
      'audi7.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/AuditedReports/2017.pdf',
      'audi8.text': 'Аудиттелетін мәлімдемелер 2015 жыл',
      'audi8.date': '05 наурыз 2016',
      'audi8.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/AuditedReports/2016.pdf',
      'audi9.text': 'Аудиттелетін мәлімдемелер 2014 жыл',
      'audi9.date': '19 наурыз 2015',
      'audi9.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/AuditedReports/2015.pdf',
    },
  },
  ru: {
    finance: {
      'finance.title': 'Финансовые показатели',
      'finance.text1': 'Финансовая отчетность',
      'finance.text2': 'Аудированные отчеты',

      'finance1.text10':
        'Бухгалтерский баланс и отчёт о прибылях и убытках по состоянию на 01 октября 2025 года',
      'finance1.date10': '1 октября 2025',
      'finance1.url10':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2025/01.10.2025_ru.pdf',

      'finance1.text9':
        'Бухгалтерский баланс и отчёт о прибылях и убытках по состоянию на 01 июля 2025 года',
      'finance1.date9': '1 июля 2025',
      'finance1.url9':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2025/01.07.2025%20ru.pdf',

      'finance1.text8':
        'Бухгалтерский баланс и отчёт о прибылях и убытках по состоянию на 01 апреля 2025 года',
      'finance1.date8': '10 апреля 2025',
      'finance1.url8':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2025/01.04.2025_v3_ru.pdf',

      'finance1.text7':
        'Бухгалтерский баланс и отчёт о прибылях и убытках по состоянию на 01 января 2025 года',
      'finance1.date7': '01 января 2025',
      'finance1.url7':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2025/january.pdf',
      'finance1.text6':
        'Бухгалтерский баланс и отчёт о прибылях и убытках по состоянию на 01 октября 2024 года',
      'finance1.date6': '01 октября 2024',
      'finance1.url6':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2024/october_ru.pdf',
      'finance1.text5':
        'Бухгалтерский баланс и отчёт о прибылях и убытках по состоянию на 01 июля 2024 года',
      'finance1.date5': '01 июля 2024',
      'finance1.url5':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2024/july.xlsx',
      'finance1.text4':
        'Бухгалтерский баланс и отчёт о прибылях и убытках по состоянию на 01 апреля 2024 года',
      'finance1.date4': '01 апреля 2024',
      'finance1.url4':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2024/april.xlsx',
      'finance1.text3':
        'Бухгалтерский баланс и отчёт о прибылях и убытках по состоянию на 01 января 2024 года',
      'finance1.date3': '01 января 2024',
      'finance1.url3':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2024/january.xlsx',
      'finance1.text2':
        'Бухгалтерский баланс и отчёт о прибылях и убытках по состоянию на 01 октября 2023 года',
      'finance1.date2': '09 октября 2023',
      'finance1.url2':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2023/october.xlsx',
      'finance1.text1':
        'Бухгалтерский баланс и отчёт о прибылях и убытках по состоянию на 01 июля 2023 года',
      'finance1.date1': '14 июля 2023',
      'finance1.url1':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2023/july.xlsx',
      'finance1.text':
        'Бухгалтерский баланс и отчёт о прибылях и убытках по состоянию на 01 апреля 2023 года',
      'finance1.date': '07 апреля 2023',
      'finance1.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2023/april.xlsx',
      'finance2.text':
        'Бухгалтерский баланс и отчёт о прибылях и убытках по состоянию на 01 января 2023 года',
      'finance2.date': '01 января 2023',
      'finance2.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2023/january.xlsx',
      'finance3.text':
        'Бухгалтерский баланс и отчёт о прибылях и убытках по состоянию на 01 октября 2022 года',
      'finance3.date': '07 октября 2022',
      'finance3.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2022/october.xlsx',
      'finance4.text':
        'Бухгалтерский баланс и отчёт о прибылях и убытках по состоянию на 01 июля 2022 года',
      'finance4.date': '08 июля 2022',
      'finance4.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2022/july.xlsx',
      'finance5.text':
        'Бухгалтерский баланс и отчёт о прибылях и убытках по состоянию на 01 апреля 2022 года',
      'finance5.date': '01 апреля 2022',
      'finance5.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2022/april.xlsx',
      'finance6.text':
        'Бухгалтерский баланс и отчёт о прибылях и убытках по состоянию на 01 января 2022 года',
      'finance6.date': '09 января 2022',
      'finance6.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2022/january.xlsx',
      'finance7.text':
        'Бухгалтерский баланс и отчёт о прибылях и убытках по состоянию на 01 октября 2021 года',
      'finance7.date': '08 октября 2021',
      'finance7.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2021/october.xlsx',
      'finance8.text':
        'Бухгалтерский баланс и отчёт о прибылях и убытках по состоянию на 01 июля 2021 года',
      'finance8.date': '09 июля 2021',
      'finance8.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2021/july.xlsx',
      'finance9.text':
        'Бухгалтерский баланс и отчёт о прибылях и убытках по состоянию на 01 апреля 2021 года',
      'finance9.date': '08 апреля 2021',
      'finance9.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2021/april.xlsx',
      'finance10.text':
        'Бухгалтерский баланс и отчёт о прибылях и убытках по состоянию на 01 января 2021 года',
      'finance10.date': '03 января 2021',
      'finance10.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2021/january.xlsx',
      'finance11.text':
        'Бухгалтерский баланс и отчёт о прибылях и убытках по состоянию на 01 октября 2020 года',
      'finance11.date': '07 октября 2020',
      'finance11.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2020/october.xlsx',
      'finance12.text':
        'Бухгалтерский баланс и отчёт о прибылях и убытках по состоянию на 01 июля 2020 года',
      'finance12.date': '08 июля 2020',
      'finance12.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2020/july.xlsx',
      'finance13.text':
        'Бухгалтерский баланс и отчёт о прибылях и убытках по состоянию на 01 апреля 2020 года',
      'finance13.date': '09 апреля 2020',
      'finance13.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2020/april.xlsx',
      'finance14.text':
        'Бухгалтерский баланс и отчёт о прибылях и убытках по состоянию на 01 января 2020 года',
      'finance14.date': '13 января 2020',
      'finance14.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2020/january.xlsx',
      'finance15.text':
        'Бухгалтерский баланс и отчёт о прибылях и убытках по состоянию на 01 октября 2019 года.',
      'finance15.date': '08 октября 2019',
      'finance15.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2019/october.xlsx',
      'finance16.text':
        'Бухгалтерский баланс и отчёт о прибылях и убытках по состоянию на 01 июля 2019 года',
      'finance16.date': '09 июля 2019',
      'finance16.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2019/july.xlsx',
      'finance17.text':
        'Бухгалтерский баланс и отчёт о прибылях и убытках по состоянию на 01 апреля 2019 года',
      'finance17.date': '08 апреля 2019',
      'finance17.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2019/april.xlsx',
      'finance18.text':
        'Бухгалтерский баланс и отчёт о прибылях и убытках по состоянию на 01 января 2019 года',
      'finance18.date': '11 января 2019',
      'finance18.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2019/january.xlsx',
      'finance19.text':
        'Бухгалтерский баланс и отчёт о прибылях и убытках по состоянию на 01 октября 2018 года',
      'finance19.date': '09 октября 2018',
      'finance19.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2018/october.xls',
      'finance20.text':
        'Бухгалтерский баланс и отчёт о прибылях и убытках по состоянию на 01 июля 2018 года',
      'finance20.date': '11 июля 2018',
      'finance20.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2018/july.xls',
      'finance21.text':
        'Бухгалтерский баланс и отчёт о прибылях и убытках по состоянию на 01 апреля 2018 года',
      'finance21.date': '01 апреля 2018',
      'finance21.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2018/april.xls',
      'finance22.text1':
        'Бухгалтерский баланс и отчёт о прибылях и убытках по состоянию на 01 марта 2018 года',
      'finance22.date1': '01 марта 2018',
      'finance22.url1':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2018/march.xls',
      'finance22.text':
        'Бухгалтерский баланс и отчёт о прибылях и убытках по состоянию на 01 января 2018 года',
      'finance22.date': '01 января 2018',
      'finance22.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2018/january.xls',
      'finance23.text':
        'Бухгалтерский баланс и отчёт о прибылях и убытках по состоянию на 01 октября 2017 года',
      'finance23.date': '01 октября 2017',
      'finance23.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2017/october.xls',
      'finance24.text':
        'Бухгалтерский баланс и отчёт о прибылях и убытках по состоянию на 01 июля 2017 года',
      'finance24.date': '01 июля 2017',
      'finance24.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2017/july.xls',
      'finance25.text1':
        'Бухгалтерский баланс и отчёт о прибылях и убытках по состоянию на 01 мая 2017 года',
      'finance25.date1': '01 мая 2017',
      'finance25.url1':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2017/may.xls',
      'finance25.text':
        'Бухгалтерский баланс и отчёт о прибылях и убытках по состоянию на 01 апреля 2017 года',
      'finance25.date': '02 апреля 2017',
      'finance25.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2017/april.xls',
      'finance26.text1':
        'Бухгалтерский баланс и отчёт о прибылях и убытках по состоянию на 01 февраля 2017 года',
      'finance26.date1': '01 февраля 2017',
      'finance26.url1':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2017/february.xls',
      'finance26.text':
        'Бухгалтерский баланс и отчёт о прибылях и убытках по состоянию на 01 января 2017 года',
      'finance26.date': '02 января 2017',
      'finance26.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2017/january.xls',
      'finance27.text1':
        'Бухгалтерский баланс и отчет о прибылях и убытках по состоянию на 01 декабря 2016 года',
      'finance27.date1': '01 декабря 2016',
      'finance27.url1':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2016/december.xls',
      'finance27.text':
        'Бухгалтерский баланс и отчет о прибылях и убытках по состоянию на 01 октября 2016 года',
      'finance27.date': '01 октября 2016',
      'finance27.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2016/october.xls',
      'finance28.text':
        'Бухгалтерский баланс и отчет о прибылях и убытках по состоянию на 01 июля 2016 года',
      'finance28.date': '01 июля 2016',
      'finance28.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2016/july.xls',
      'finance29.text':
        'Бухгалтерский баланс и отчёт о прибылях и убытках по состоянию на 01 апреля 2016 года',
      'finance29.date': '01 апреля 2016',
      'finance29.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2016/april.xls',
      'finance30.text':
        'Бухгалтерский баланс и отчёт о прибылях и убытках по состоянию на 05 января 2016 года',
      'finance30.date': '05 января 2016',
      'finance30.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2016/january.xls',
      'finance31.text':
        'Бухгалтерский баланс и отчёт о прибылях и убытках по состоянию на 01 октября 2015 года',
      'finance31.date': '01 октября 2015',
      'finance31.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2015/october.xls',
      'finance32.text':
        'Бухгалтерский баланс и отчёт о прибылях и убытках по состоянию на 01 июля 2015 года',
      'finance32.date': '01 июля 2015',
      'finance32.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2015/july.xls',
      'finance33.text':
        'Бухгалтерский баланс и отчёт о прибылях и убытках по состоянию на 01 апреля 2015 года',
      'finance33.date': '01 апреля 2015',
      'finance33.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2015/april.xls',
      'finance34.text':
        'Бухгалтерский баланс и отчёт о прибылях и убытках по состоянию на 01 января 2015 года',
      'finance34.date': '09 января 2015',
      'finance34.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2015/january.xls',
      'finance35.text':
        'Бухгалтерский баланс и отчёт о прибылях и убытках по состоянию на 01 октября 2014 года',
      'finance35.date': '30 сентября 2014',
      'finance35.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2014/september.xls',
      'finance36.text':
        'Бухгалтерский баланс и отчёт о прибылях и убытках по состоянию на 01 июля 2014 года',
      'finance36.date': '01 июля 2014',
      'finance36.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2014/july.xls',
      'finance37.text': 'Отчет о доходах и расходах на 01 апреля 2014 года',
      'finance37.date': '01 апреля 2014',
      'finance37.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2014/april_otchet.pdf',
      'finance38.text':
        'Бухгалтерский баланс по состоянию на 01 апреля 2014 года',
      'finance38.date': '01 апреля 2014',
      'finance38.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2014/april_balance.pdf',
      'finance39.text': 'Отчет о доходах и расходах за 12 месяцев 2013 года',
      'finance39.date': '01 января 2014',
      'finance39.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2014/january.pdf',
      'finance40.text':
        'Бухгалтерский баланс по состоянию на 31 декабря 2013 года',
      'finance40.date': '01 декабря 2013',
      'finance40.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2013/december.pdf',
      'finance41.text': 'Баланс по состоянию на 01 сентября 2013 года',
      'finance41.date': '01 сентября 2013',
      'finance41.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2013/september_balance.pdf',
      'finance42.text':
        'Отчет о прибылях и убытках по состоянию на 01 сентября 2013 года',
      'finance42.date': '01 сентября 2013',
      'finance42.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2013/september_otchet.pdf',
      'finance43.text':
        'Отчет о прибылях и убытках по состоянию на 01 июля 2013 года',
      'finance43.date': '01 июля 2013',
      'finance43.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2013/july_otchet.pdf',
      'finance44.text': 'Баланс по состоянию на 01 июля 2013 года',
      'finance44.date': '01 июля 2013',
      'finance44.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2013/july_balance.pdf',
      'finance45.text':
        'Отчет о прибылях и убытках по состоянию на 01 апреля 2013 года',
      'finance45.date': '01 апреля 2013',
      'finance45.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2013/april_otchet.pdf',
      'finance46.text': 'Баланс по состоянию на 01 апреля 2013 года',
      'finance46.date': '01 апреля 2013',
      'finance46.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/FinancialStatements/2013/april_balance.pdf',
      'audi11.text': 'Аудированная отчетность за 2024 год',
      'audi11.date': '13 августа 2025',
      'audi11.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/AuditedReports/2025.pdf',
      'audi10.text': 'Аудированная отчетность за 2023 год',
      'audi10.date': '29 августа 2024',
      'audi10.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/AuditedReports/2024.pdf',
      'audi1.text': 'Аудированная отчетность за 2022 год',
      'audi1.date': '02 апреля 2023',
      'audi1.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/AuditedReports/2023.pdf',
      'audi2.text': 'Аудированная отчетность за 2021 год',
      'audi2.date': '02 апреля 2022',
      'audi2.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/AuditedReports/2022.pdf',
      'audi3.text': 'Аудированная отчетность за 2020 год',
      'audi3.date': '08 апреля 2021',
      'audi3.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/AuditedReports/2021.pdf',
      'audi4.text': 'Аудированная отчетность за 2019 год',
      'audi4.date': '01 апреля 2020',
      'audi4.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/AuditedReports/2020.pdf',
      'audi5.text': 'Аудированная отчетность за 2018 год',
      'audi5.date': '01 июня 2019',
      'audi5.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/AuditedReports/2019.pdf',
      'audi6.text': 'Аудированная отчетность за 2017 год',
      'audi6.date': '01 апреля 2018',
      'audi6.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/AuditedReports/2018.pdf',
      'audi7.text': 'Аудированная отчетность за 2016 год',
      'audi7.date': '01 марта 2017',
      'audi7.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/AuditedReports/2017.pdf',
      'audi8.text': 'Аудированная отчетность за 2015 год',
      'audi8.date': '05 марта 2016',
      'audi8.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/AuditedReports/2016.pdf',
      'audi9.text': 'Аудированная отчетность за 2014 год',
      'audi9.date': '09 марта 2015',
      'audi9.url':
        'https://api.jgarant.kz/admin/media/Site/FinancialIndicators/AuditedReports/2015.pdf',
    },
  },
};

export default financeResources;
